import React from 'react';

export const LoadSpinner = () => {
  return (
    <div className='loading'>
      <i className='fa-solid fa-arrows-rotate fa-spin' title='spinner'></i>
    </div>
  );
};

export const SubmissionsLoading = () => {
  return (
    <tr className='loading'>
      <td colSpan='100%'>
        <i className='fa-solid fa-arrows-rotate fa-spin' title='spinner'></i>
      </td>
    </tr>
  );
};

export const OpaqueSpinner = () => {
  return (
    <div className='opaque-spinner-bg'>
      <i className='fa-solid fa-arrows-rotate fa-spin' title='spinner'></i>
    </div>
  );
};

export const BigSpinner = ({ show }) => {
  return (
    <div
      className='spinner-container'
      style={{ display: show ? 'block' : 'none' }}
    >
      <i
        className='fa-solid fa-arrows-rotate fa-spin big-spinner'
        title='spinner'
      ></i>
    </div>
  );
};
